import { useState } from "react";
import { Reveal, PillButton } from "./ui";
import { productQuestions, scoreProduct, productResult } from "./quizData";
import { postProductQuiz } from "./api";

export const ProductQuiz = () => {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  const total = productQuestions.length;
  const choose = (opt) => {
    const next = [...answers.slice(0, step), opt];
    setAnswers(next);
    if (step + 1 < total) setStep(step + 1);
    else {
      const r = scoreProduct(next);
      setResult({ ...r, copy: productResult(r) });
    }
  };
  const restart = () => { setStep(0); setAnswers([]); setResult(null); setSaved(false); setFirst(""); setEmail(""); };
  const save = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSaving(true);
    try {
      await postProductQuiz({ first_name: first, email, size: result.size, material: result.material, style: result.style, answers });
      setSaved(true);
    } catch {} finally { setSaving(false); }
  };

  const q = productQuestions[step];
  return (
    <section id="product-quiz" className="px-6 md:px-12 lg:px-16 py-16 md:py-24 border-t border-[var(--line)]" data-testid="product-quiz-section">
      <div className="max-w-[760px] mx-auto">
        <Reveal>
          <div className="text-center">
            <span className="eyebrow">Play · The Sash Matchmaker</span>
            <h2 className="mt-4 text-[clamp(2rem,4.5vw,3.2rem)] leading-[1.03]">
              Find your <span className="italic" style={{ color: "var(--clay)" }}>perfect Sash.</span>
            </h2>
            <p className="mt-4 text-[1.05rem] text-[var(--ink-soft)]">
              Six quick questions. No wrong answers, unless you say you carry only lip balm and then somehow need a Full Sash.
            </p>
          </div>
        </Reveal>

        <div className="result-card mt-10" data-testid="product-quiz-card">
          {!result ? (
            <div>
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-bold text-[var(--tan-deep)]">Question {step + 1} of {total}</span>
                {step > 0 && (
                  <button className="text-sm text-[var(--ink-soft)] underline" onClick={() => setStep(step - 1)} data-testid="product-quiz-back">Back</button>
                )}
              </div>
              <div className="qp-bar mb-7"><div className="qp-fill" style={{ width: `${(step / total) * 100}%` }} /></div>
              <h3 className="sash-serif text-2xl md:text-3xl leading-tight mb-6">{q.q}</h3>
              <div className="space-y-3">
                {q.options.map((o) => (
                  <button
                    key={o.k}
                    className={`quiz-opt ${answers[step] && answers[step].k === o.k ? "sel" : ""}`}
                    onClick={() => choose(o)}
                    data-testid={`product-quiz-opt-${step}-${o.k}`}
                  >
                    <span className="qk">{o.k}</span>{o.t}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div data-testid="product-quiz-result">
              <span className="eyebrow">Your Sash Match</span>
              <h3 className="mt-3 sash-serif text-[clamp(1.7rem,4vw,2.6rem)] leading-tight">{result.copy.title}</h3>
              <p className="mt-4 text-[1.05rem] leading-relaxed text-[var(--ink-soft)]">{result.copy.blurb}</p>
              <p className="mt-6 text-sm font-bold text-[var(--tan-deep)] uppercase tracking-wider">When Sash comes back, keep an eye out for:</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {result.copy.watchFor.map((w) => (<span key={w} className="pill-tag">{w}</span>))}
              </div>

              {saved ? (
                <p className="mt-8 sash-serif italic text-xl text-[var(--tan-deep)]" data-testid="product-quiz-saved">
                  Saved! We'll tell you the moment your Sash match is back in stock. ✨
                </p>
              ) : (
                <form onSubmit={save} className="mt-8 pt-6 border-t border-[var(--line)]" data-testid="product-quiz-save-form">
                  <p className="mb-3 font-bold">Tell me when my Sash is back:</p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <input className="sf-input sm:max-w-[150px]" placeholder="First name" value={first} onChange={(e) => setFirst(e.target.value)} data-testid="product-quiz-firstname" />
                    <input className="sf-input flex-1" type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="product-quiz-email" />
                    <PillButton type="submit" testid="product-quiz-save">{saving ? "…" : "Tell Me When It's Back"}</PillButton>
                  </div>
                </form>
              )}
              <button className="mt-6 text-sm text-[var(--ink-soft)] underline" onClick={restart} data-testid="product-quiz-restart">Retake the quiz</button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
